import styled from 'styled-components';

export const Style = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 36px;

  h2 {
    font-size: 20px;
    font-weight: 500;
  }

  .header {
    display: flex;
    gap: 30px;
  }

  .date {
    display: flex;

    span {
      font-size: var(--font-size-lg);
      font-weight: 300;
    }

    svg {
      margin-top: 5px;
      margin-right: 10px;
      color: var(--color-primary-70);
    }
  }

  .data {
    display: flex;

    .section {
      padding: 9px var(--size-lg) 0px var(--size-lg);
      flex: 1;
      border-right: 2px solid #E9E9E9;

      &:first-of-type {
        padding-left: 0px;
      }
      
      &:last-of-type {
        border-right: 0px;
      }

      h2, p {
        margin-bottom: 0px;
      }

      h2 {
        margin-bottom: 21px;
      }

      div {
        .title {
          color: #8C8C8C;
          font-size: 14px;
          font-weight: 600;
          margin-bottom: 11px;
        }

        .content {
          margin-left: 12px;
          font-size: var(--font-size-lg);
          font-weight: 500;
          color: #001529;
          margin-bottom: 20px;
          
          &.risk {
            font-weight: 700;

            &.very-low {
              color: #73D13D; 
            }

            &.low {
              color: #FADB14;
            }

            &.medium {
              color: #FA8C16;
            }

            &.high {
              color: #FF4D4F;
            }

            &.very-high {
              color: #CF1322;
            }
          }
        }
      }
    }
  }

  .details {
    overflow: hidden;

    h2 {
      margin-bottom: var(--size-lg);
    }

    p { 
      font-size: var(--font-size-lg);
      font-weight: 500;
      margin-bottom: 0px;
    }
  }

  .designated-implementer {
    .info {
      width: 100%;
      border: 1px dashed #D7DAEA;

      .item {
        display: flex;
        padding: 10px;

        &:nth-child(even) {
          background: #F9FAFC;
        }

        &:first-of-type {
          padding-top: 13px;
        }

        &:last-of-type {
          padding-bottom: 13px;
        }

        span {
          flex: 1;
          padding: 0px 10px;
          font-size: 14px;
          font-weight: 400;
          color: #262626;

          &.value {
            font-weight: 600;
          }
        }
      }
    }
  }

  &.layout-b {
    .tag-in-progress {
      color: #2F54EB;
      border-color: #2F54EB;
      background: #F0F5FF;
    }
    
    .header {
      gap: 11px;

      .info-source {
        label {
          font-weigth: 500;
          margin-bottom: 0px;
          font-size: var(--font-size-lg);
          color: #001529;
        }
      }
    }

    .data {
      .section {
        div {
          .title {
            color: #8C8C8C;
            font-size: 14px;
            font-weight: 500;
            margin-bottom: 11px;
          }
        }
      }
    }

    .designated-implementer { 
      .value {
        font-weight: 400 !important;
      }
    }
  }
`;

